import { window } from "global";
import { useEffect } from "react";
import { MediaQuery } from "@outplayed/responsive";
import { TierListHeader } from "../../TierListHeader";
import { TierListPageNav } from "../../TierListPageNav";
import { TierListFilterManager } from "../../TierListFilterManager";
import { DuoTierListTable } from "./DuoTierListTable";
import { TierListTablePlaceholder } from "../../common/TierListTablePlaceholder";
import { TierListTableError } from "../../common/TierListTableError";

import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useDuoTierList } from "@ugg/shared/api/requests/tier-lists/duo-tier-list";
import { TIER_LIST_PAGES } from "@ugg/shared/pages/tier-list-pages";

type BannerProp = {
  bannerSlot?: JSX.Element | null;
};

export const DuoTierListContainer = ({ bannerSlot }: BannerProp) => {
  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const { data: duoData, loading, error } = useDuoTierList({ params: queryParams, ssr: true });

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  const validatedParams = validateQueryParams(TIER_LIST_PAGES.DUO_TIER_LIST, queryParams, true);
  const filters = { ...validatedParams };
  const { data, lastUpdated, totalMatches } = duoData || {};

  let table = null;
  if (!window) {
    table = null;
  } else if (loading) {
    table = <TierListTablePlaceholder />;
  } else if (error) {
    table = <TierListTableError />;
  } else {
    table = <DuoTierListTable filters={filters} data={data} />;
  }

  return (
    <div>
      <TierListHeader className="mb-[24px]" totalMatches={totalMatches} lastUpdated={lastUpdated} loading={loading} includeMeta />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div>
          <TierListPageNav />
        </div>
      </MediaQuery>
      {bannerSlot ?? null}
      <TierListFilterManager className="my-[24px]" />
      {table}
    </div>
  );
};
